import { API_ENDPOINTS, get } from './api';

const buildQueryParams = (params = {}) => {
  const query = new URLSearchParams();

  if (params.level) query.append('level', params.level);
  if (params.startDate) query.append('startDate', params.startDate);
  if (params.endDate) query.append('endDate', params.endDate);

  return query.toString();
};

export const fetchNotifications = async (params = {}) => {
  const queryString = buildQueryParams(params);
  const endpoint = queryString ? `${API_ENDPOINTS.NOTIFICATION_LOGS}?${queryString}` : API_ENDPOINTS.NOTIFICATION_LOGS;
  return get(endpoint);
};

export const normalizeNotificationPayload = (response) => {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.items)) return response.items;
  if (Array.isArray(response.results)) return response.results;
  return [];
};

export default {
  fetchNotifications,
  normalizeNotificationPayload
};
